import React, { useState } from "react";
import Header from "../../components/header/header";
import EmbeddablePaymentComponent from "./embeddablePaymentComponent";
const PaymentInformationRedirectionPage = () => {
  return (
    <React.Fragment>
      <Header />
      <EmbeddablePaymentComponent />
    </React.Fragment>
  );
};
export default PaymentInformationRedirectionPage;
